import React from "react";
import "./style.css";
function Input(props) {
  return <input {...props} className="input" />;
}

export default Input;
